// extracted by mini-css-extract-plugin
export default {"face":"Face_face__OwqXX","name":"Face_name__RhmtX","jobTitle":"Face_jobTitle__0GluU"};